// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"354":"61165df4","668":"7af99094","838":"05236d80"}[chunkId] + ".js";
};